import { render, staticRenderFns } from "./WF2_2_Contact_SH.vue?vue&type=template&id=0421b4ca"
import script from "./WF2_2_Contact_SH.vue?vue&type=script&lang=js"
export * from "./WF2_2_Contact_SH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports